import Emitter from "./Emitter";

export default class GameAutoplayEnd extends Emitter {
    constructor(gb) {
        super(gb);
    }

    POKERSTARS_handler() {
        const dataForXc = {
            "msgId": "rg2xcGameStatusUpdated",
            "status": "autoPlayEnd",
        }

        if (this.gb.api && this.gb.api.settings && this.gb.api.settings.pokerstarsOrigin) {
            window.parent.postMessage(JSON.stringify(dataForXc), this.gb.api.settings.pokerstarsOrigin);
        } else {
            window.parent.postMessage(JSON.stringify(dataForXc), "*");
        }
    }

    PLAYTECH_handler() {
        if (this.gb.ptResFeat && this.gb.ptResFeat.includes('autoplay')) {
            var interval = setInterval(() => {
                if (!this.gb.isSpinning) {
                    let data = {_type: "ucip.autoplay.g2wAutoplayEndNotification"};
                    if (this.gb.settings.nativeMobileApp) {
                        data.handled = true;
                        window.parent.postMessage(JSON.stringify(data));
                    } else {
                        this.emitParent(JSON.stringify(data));
                    }

                    clearInterval(interval)

                    return
                }

            }, 150)
        }
    }

    _default() {
        this.emitTop({ wpgaction: "autoplayEnd" });
        this.emitParent({ wpgaction: "autoplayEnd.parent" });
        this.emitiOS({ wpgaction: "autoplayEnd" });
    }
}
